import React, { useState, useRef, useEffect } from "react";
import { ChevronDown, Globe } from "lucide-react";

// Top currencies that appear first
const topCurrencies = [
  { code: "USD", name: "US Dollar" },
  { code: "CAD", name: "Canadian Dollar" },
  { code: "EUR", name: "Euro" },
  { code: "GBP", name: "British Pound" },
  { code: "SAR", name: "Saudi Riyal" },
];

// All currencies
const allCurrencies = [
  // --- Active ---
  { code: "AED", name: "UAE Dirham" },
  { code: "AUD", name: "Australian Dollar" },
  { code: "BRL", name: "Brazilian Real" },
  { code: "CHF", name: "Swiss Franc" },
  { code: "CLP", name: "Chilean Peso" },
  { code: "CNY", name: "Chinese Yuan" },
  { code: "COP", name: "Colombian Peso" },
  { code: "CZK", name: "Czech Koruna" },
  { code: "DKK", name: "Danish Krone" },
  { code: "HKD", name: "Hong Kong Dollar" },
  { code: "HUF", name: "Hungarian Forint" },
  { code: "IDR", name: "Indonesian Rupiah" },
  { code: "ILS", name: "Israeli Shekel" },
  { code: "INR", name: "Indian Rupee" },
  { code: "ISK", name: "Icelandic Króna" },
  { code: "JPY", name: "Japanese Yen" },
  { code: "KRW", name: "South Korean Won" },
  { code: "KWD", name: "Kuwaiti Dinar" },
  { code: "MXN", name: "Mexican Peso" },
  { code: "MYR", name: "Malaysian Ringgit" },
  { code: "NOK", name: "Norwegian Krone" },
  { code: "NZD", name: "New Zealand Dollar" },
  { code: "PHP", name: "Philippine Peso" },
  { code: "PLN", name: "Polish Złoty" },
  { code: "QAR", name: "Qatari Riyal" },
  { code: "RON", name: "Romanian Leu" },
  { code: "SEK", name: "Swedish Krona" },
  { code: "SGD", name: "Singapore Dollar" },
  { code: "THB", name: "Thai Baht" },
  { code: "TRY", name: "Turkish Lira" },
  { code: "ZAR", name: "South African Rand" },

  // --- No rates yet ---
  // { code: "AFN", name: "Afghan Afghani" },
  // { code: "ALL", name: "Albanian Lek" },
  // { code: "AMD", name: "Armenian Dram" },
  // { code: "ANG", name: "Netherlands Antillean Guilder" },
  // { code: "ARS", name: "Argentine Peso" },
  // { code: "AWG", name: "Aruban Florin" },
  // { code: "AZN", name: "Azerbaijani Manat" },
  // { code: "BBD", name: "Barbadian Dollar" },
  // { code: "BDT", name: "Bangladeshi Taka" },
  // { code: "BGN", name: "Bulgarian Lev" },
  // { code: "BHD", name: "Bahrain Dinar" },
  // { code: "BIF", name: "Burundian Franc" },
  // { code: "BMD", name: "Bermudian Dollar" },
  // { code: "BOB", name: "Bolivian Boliviano" },
  // { code: "BYN", name: "Belarusian Ruble" },
  // { code: "BZD", name: "Belize Dollar" },
  // { code: "CDF", name: "Congolese Franc" },
  // { code: "CRC", name: "Costa Rican Colón" },
  // { code: "CVE", name: "Cape Verdean Escudo" },
  // { code: "DJF", name: "Djiboutian Franc" },
  // { code: "DOP", name: "Dominican Peso" },
  // { code: "EGP", name: "Egyptian Pound" },
  // { code: "ETB", name: "Ethiopian Birr" },
  // { code: "FJD", name: "Fijian Dollar" },
  // { code: "FKP", name: "Falkland Islands Pound" },
  // { code: "GEL", name: "Georgian Lari" },
  // { code: "GHS", name: "Ghanaian Cedi" },
  // { code: "GIP", name: "Gibraltar Pound" },
  // { code: "GMD", name: "Gambian Dalasi" },
  // { code: "GNF", name: "Guinean Franc" },
  // { code: "GTQ", name: "Guatemalan Quetzal" },
  // { code: "GYD", name: "Guyanese Dollar" },
  // { code: "HNL", name: "Honduran Lempira" },
  // { code: "HRK", name: "Croatian Kuna" },
  // { code: "IMP", name: "Manx Pound" },
  // { code: "IQD", name: "Iraqi Dinar" },
  // { code: "IRR", name: "Iranian Rial" },
  // { code: "JEP", name: "Jersey Pound" },
  // { code: "JMD", name: "Jamaican Dollar" },
  // { code: "JOD", name: "Jordanian Dinar" },
  // { code: "KES", name: "Kenyan Shilling" },
  // { code: "KGS", name: "Kyrgyzstani Som" },
  // { code: "KHR", name: "Cambodian Riel" },
  // { code: "KID", name: "Kiribati Dollar" },
  // { code: "KMF", name: "Comorian Franc" },
  // { code: "KYD", name: "Cayman Islands Dollar" },
  // { code: "KZT", name: "Kazakhstani Tenge" },
  // { code: "LAK", name: "Lao Kip" },
  // { code: "LBP", name: "Lebanese Pound" },
  // { code: "LKR", name: "Sri Lankan Rupee" },
  // { code: "LRD", name: "Liberian Dollar" },
  // { code: "MAD", name: "Moroccan Dirham" },
  // { code: "MDL", name: "Moldovan Leu" },
  // { code: "MGA", name: "Malagasy Ariary" },
  // { code: "MKD", name: "Macedonian Denar" },
  // { code: "MMK", name: "Myanmar Kyat" },
  // { code: "MNT", name: "Mongolian Tögrög" },
  // { code: "MRO", name: "Mauritanian Ouguiya" },
  // { code: "MUR", name: "Mauritian Rupee" },
  // { code: "MWK", name: "Malawian Kwacha" },
  // { code: "MZN", name: "Mozambican Metical" },
  // { code: "NAD", name: "Namibian Dollar" },
  // { code: "NGN", name: "Nigerian Naira" },
  // { code: "NIO", name: "Nicaraguan Córdoba" },
  // { code: "NPR", name: "Nepalese Rupee" },
  // { code: "OMR", name: "Omani Rial" },
  // { code: "PAB", name: "Panamanian Balboa" },
  // { code: "PEN", name: "Peruvian Sol" },
  // { code: "PGK", name: "Papua New Guinean Kina" },
  // { code: "PKR", name: "Pakistani Rupee" },
  // { code: "PYG", name: "Paraguayan Guaraní" },
  // { code: "RON", name: "Romanian Leu" },
  // { code: "RSD", name: "Serbian Dinar" },
  // { code: "RUB", name: "Russian Ruble" },
  // { code: "RWF", name: "Rwandan Franc" },
  // { code: "SBD", name: "Solomon Islands Dollar" },
  // { code: "SHP", name: "Saint Helena Pound" },
  // { code: "SLL", name: "Sierra Leonean Leone" },
  // { code: "SOS", name: "Somali Shilling" },
  // { code: "SRD", name: "Surinamese Dollar" },
  // { code: "SSP", name: "South Sudanese Pound" },
  // { code: "STN", name: "São Tomé and Príncipe Dobra" },
  // { code: "SYP", name: "Syrian Pound" },
  // { code: "SZL", name: "Eswatini Lilangeni" },
  // { code: "TJS", name: "Tajikistani Somoni" },
  // { code: "TMT", name: "Turkmenistan Manat" },
  // { code: "TND", name: "Tunisian Dinar" },
  // { code: "TOP", name: "Tongan Paʻanga" },
  // { code: "TTD", name: "Trinidad and Tobago Dollar" },
  // { code: "TVD", name: "Tuvaluan Dollar" },
  // { code: "TZS", name: "Tanzanian Shilling" },
  // { code: "UAH", name: "Ukrainian Hryvnia" },
  // { code: "UGX", name: "Ugandan Shilling" },
  // { code: "UYU", name: "Uruguayan Peso" },
  // { code: "UZS", name: "Uzbekistani Som" },
  // { code: "VND", name: "Vietnamese Dong" },
  // { code: "VUV", name: "Vanuatu Vatu" },
  // { code: "WST", name: "Samoan Tālā" },
  // { code: "XAF", name: "Central African CFA Franc" },
  // { code: "XCD", name: "East Caribbean Dollar" },
  // { code: "XOF", name: "West African CFA Franc" },
  // { code: "XPF", name: "CFP Franc" },
  // { code: "YER", name: "Yemeni Rial" },
];

function CurrencySelector({ selectedCurrency, onCurrencyChange }) {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);
  const hasLoadedRef = useRef(false);
  const [focusedIndex, setFocusedIndex] = useState(-1);
  // Filter currencies based on search term
  const filteredTopCurrencies = topCurrencies.filter(
    (currency) =>
      currency.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      currency.code.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const filteredAllCurrencies = allCurrencies.filter(
    (currency) =>
      currency.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      currency.code.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const listRef = useRef(null);
  const allFilteredCurrencies = [
    ...filteredTopCurrencies,
    ...filteredAllCurrencies,
  ];
  useEffect(() => {
    if (hasLoadedRef.current) return;
    hasLoadedRef.current = true;

    const savedCurrency = localStorage.getItem("selectedCurrency");

    if (!savedCurrency) return;

    try {
      const parsedCurrency = JSON.parse(savedCurrency);

      // ONLY hydrate if parent doesn't already control value
      if (!selectedCurrency?.code) {
        if (typeof onCurrencyChange === 'function') {
          onCurrencyChange(parsedCurrency);
        }
      }
    } catch (error) {
      console.error("Error parsing saved currency:", error);
    }
  }, [onCurrencyChange, selectedCurrency]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isOpen) return;

      if (e.key === "ArrowDown") {
        e.preventDefault();
        setFocusedIndex((prev) =>
          prev < allFilteredCurrencies.length - 1 ? prev + 1 : prev,
        );
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        setFocusedIndex((prev) => (prev > 0 ? prev - 1 : 0));
      } else if (e.key === "Enter" && focusedIndex >= 0) {
        e.preventDefault();
        handleCurrencySelect(allFilteredCurrencies[focusedIndex]);
      } else if (e.key === "Escape") {
        setIsOpen(false);
        setFocusedIndex(-1);
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, focusedIndex, allFilteredCurrencies]);
  // Load currency from localStorage on component mount
  // useEffect(() => {
  //   const savedCurrency = localStorage.getItem('selectedCurrency');
  //   if (savedCurrency) {
  //     try {
  //       const parsedCurrency = JSON.parse(savedCurrency);
  //       onCurrencyChange(parsedCurrency);
  //     } catch (error) {
  //       console.error('Error parsing saved currency:', error);
  //     }
  //   }
  // }, [onCurrencyChange]);

  // Save currency to localStorage when it changes
  useEffect(() => {
    if (selectedCurrency) {
      localStorage.setItem(
        "selectedCurrency",
        JSON.stringify(selectedCurrency),
      );
    }
  }, [selectedCurrency]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    if (focusedIndex < 0 || !listRef.current) return;
    const items = listRef.current.querySelectorAll("button");
    const target = items[focusedIndex];
    if (target) {
      target.scrollIntoView({ block: "nearest" });
    }
  }, [focusedIndex]);

  // const handleCurrencySelect = (currency) => {
  //   onCurrencyChange(currency);
  //   setIsOpen(false);
  //   setSearchTerm('');

  //   // Refresh the page after currency selection
  //   // window.location.reload();
  // };
  const handleCurrencySelect = (currency) => {
    if (!currency?.code) return;

    // prevent redundant update (THIS fixes first-click glitch)
    if (currency.code === selectedCurrency?.code) {
      setIsOpen(false);
      return;
    }

    onCurrencyChange?.(currency);
    setIsOpen(false);
    setSearchTerm("");
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-1 px-3 py-1 rounded hover:bg-white hover:bg-opacity-10 transition-colors duration-200"
      >
        <Globe size={22} />
        <span className="text-[13px]">
          {selectedCurrency ? selectedCurrency.code : "USD"}
        </span>
        <ChevronDown
          size={16}
          className={`transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`}
        />
      </button>

      {isOpen && (
        <div
          className="absolute top-full right-0 mt-1 w-64 bg-white rounded-lg shadow-lg border border-primary/40 z-50 max-h-96 overflow-hidden"
          style={{ maxWidth: "calc(100vw - 1rem)" }}
        >
          <div className="p-3 border-b border-primary/20">
            <input
              type="text"
              placeholder="Search currencies..."
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setFocusedIndex(-1);
              }}
              className="font-heading w-full text-[13px] px-3 py-2 border border-primary/30 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-slate-800 bg-navy/5 placeholder-gray-400"
              autoFocus
            />
          </div>

          {/* Currency list */}
          <div className="max-h-80 overflow-y-auto" ref={listRef}>
            {/* Top Currencies Section */}
            {(!searchTerm || filteredTopCurrencies.length > 0) && (
              <>
                <div className="px-4 py-2 bg-gray-50 border-b border-gray-200">
                  <h3 className="font-heading text-[15px] font-semibold text-gray-700">
                    Top Currencies
                  </h3>
                </div>
                {filteredTopCurrencies.map((currency) => (
                  <button
                    key={currency.code}
                    onClick={() => handleCurrencySelect(currency)}
                    className={`w-full px-4 py-3 text-left transition-colors duration-150 flex items-center justify-between border-b border-gray-100 ${
                      selectedCurrency?.code === currency.code
                        ? "bg-gold/10 text-navy"
                        : focusedIndex >= 0 && focusedIndex ===
                            filteredTopCurrencies.indexOf(currency)
                          ? "bg-gold/20 text-navy"
                          : "text-navy hover:bg-gray-50"
                    }`}
                  >
                    <div className="flex items-center space-x-3">
                      <span className="font-heading text-[13px] font-semibold text-primary">
                        {currency.code}
                      </span>
                      <span className="font-body text-gray-600 text-[13px]">
                        {currency.name}
                      </span>
                    </div>
                    {selectedCurrency?.code === currency.code && (
                      <div className="text-primary">
                        <svg
                          className="w-5 h-5"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fillRule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </div>
                    )}
                  </button>
                ))}
              </>
            )}

            {/* All Currencies Section */}
            {(!searchTerm || filteredAllCurrencies.length > 0) && (
              <>
                <div className="px-4 py-2 bg-gray-50 border-b border-gray-200">
                  <h3 className="font-heading text-[15px] font-semibold text-gray-700">
                    All Currencies
                  </h3>
                </div>
                {filteredAllCurrencies.map((currency) => (
                  <button
                    key={currency.code}
                    onClick={() => handleCurrencySelect(currency)}
                    className={`w-full px-4 py-3 text-left hover:bg-gray-50 transition-colors duration-150 flex items-center justify-between border-b border-gray-100 ${
                      selectedCurrency?.code === currency.code
                        ? "bg-blue-50 text-blue-600"
                        : focusedIndex >= 0 && focusedIndex ===
                            filteredTopCurrencies.length +
                              filteredAllCurrencies.indexOf(currency)
                          ? "bg-gold/20 text-navy"
                          : "text-gray-900"
                    }`}
                  >
                    <div className="flex items-center space-x-3">
                      <span className="font-heading text-[13px] font-semibold text-primary">
                        {currency.code}
                      </span>
                      <span className="font-body text-gray-700 text-[13px]">
                        {currency.name}
                      </span>
                    </div>
                    {selectedCurrency?.code === currency.code && (
                      <div className="text-primary">
                        <svg
                          className="w-5 h-5"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fillRule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </div>
                    )}
                  </button>
                ))}
              </>
            )}

            {/* No results message */}
            {searchTerm &&
              filteredTopCurrencies.length === 0 &&
              filteredAllCurrencies.length === 0 && (
                <div className="font-heading px-4 py-3 text-gray-400 text-center">
                  No currencies found
                </div>
              )}
          </div>
        </div>
      )}
    </div>
  );
}

export default CurrencySelector;
